export const COLORS = [
  // Warm colors (reds, oranges, yellows)
  '#EF4444', // red-500
  '#F97316', // orange-500
  '#EAB308', // yellow-500
  '#78350F', // yellow-900 (brown)

  // Purples and pinks
  '#D946EF', // fuchsia-500
  '#8B5CF6', // violet-500
  '#581C87', // purple-900 (dark purple)
  '#881337', // rose-900 (dark rose)

  // Greens and teals
  '#10B981', // emerald-500
  '#0F766E', // teal-700
  '#06B6D4', // cyan-500

  // Blues
  '#60A5FA', // blue-400
  '#2563EB', // blue-600

  // Neutral tones
  '#000000', // black
];
